import { WAIT_FOR_ACTION, ERROR_ACTION } from "redux-wait-for-action";

export const GET_SIGNATORY_INFO = "GET_SIGNATORY_INFO";
export const GET_SIGNATORY_INFO_SUCCESS = "GET_SIGNATORY_INFO_SUCCESS";
export const GET_SIGNATORY_INFO_FAIL = "GET_SIGNATORY_INFO_FAIL";
export const AUTHORIZE_SIGNATORY = "AUTHORIZE_SIGNATORY";
export const AUTHORIZE_SIGNATORY_SUCCESS = "AUTHORIZE_SIGNATORY_SUCCESS";
export const AUTHORIZE_SIGNATORY_FAIL = "AUTHORIZE_SIGNATORY_FAIL";

export const getSignatoryInfoSuccess = response => ({
  type: GET_SIGNATORY_INFO_SUCCESS,
  payload: response
});

export const getSignatoryInfoFail = () => ({
  type: GET_SIGNATORY_INFO_FAIL
});

export const getSignatoryData = data => ({
  type: GET_SIGNATORY_INFO,
  payload: data
});

export const authorizeSignatoryPromisify = data => ({
  type: AUTHORIZE_SIGNATORY,
  [WAIT_FOR_ACTION]: AUTHORIZE_SIGNATORY_SUCCESS,
  [ERROR_ACTION]: AUTHORIZE_SIGNATORY_FAIL,
  payload: data
});

export const authorizeSignatorySuccess = () => ({
  type: AUTHORIZE_SIGNATORY_SUCCESS
});

export const authorizeSignatoryFail = () => ({
  type: AUTHORIZE_SIGNATORY_FAIL
});
